export default "__VITE_ASSET__QaH2NJCB__"